// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__24v1q","signatureButtonsRight":"ModalSign_signatureButtonsRight__2DgRJ"};